<template>
	<DsModal
		class="signup-modal"
		:isOpen="active"
		@close-modal="hide"
		closeLabel="Close button"
		>
        <div ref="popup">
            <img v-if="logoUrl" :src="logoUrl" class="c-modal__logo" alt="logo" />
            <div class="c-modal__container" ref="container">
				<DsText
					class="e-heading -new"
					html-element="h2"
					tabindex="-1"
					text-type="heading-2xl"
					text-style="bold">{{ heading }}</DsText>
				<DsText
					html-element="div"
					text-type="body-lg">
					<span v-html="description" />
				</DsText>
                <form class="c-hcp__form">
                    <div class="c-hcp__form-fieldset">
                        <div class="cons-agreement">
                            <input data-testid="consentGiven" type="checkbox" autofocus name="ConsentAgreement" id="hcp-consent" v-model="consentGiven" />
							<DsText
								html-element="label"
								for="hcp-consent">
							<span v-html="consent" />
							</DsText>
                        </div>
                    </div>
					<DsButtonGroup
						desktop-direction="column"
						desktop-alignment="stretch"
						mobile-direction="column"
					>
						<DsButton
							:disabled="!consentGiven"
							@click.prevent="redirect"
							variant="primary"
							data-testid="submitButton">{{ buttonText }}</DsButton>
						<DsButton
							@click.prevent="hide"
							variant="ghost"
							data-testid="cancelButton">{{ cancelButtonText }}</DsButton>
					</DsButtonGroup>
                </form>
            </div>
        </div>
	</DsModal>
</template>

<script setup>
</script>

<script>
import Events from 'shared/settings/events.js';
import { DsButton, DsButtonGroup, DsText, DsModal } from '@coloplast/design-system';

export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        consentText: {
            type: String,
            required: true,
        },
        consentLinkText: {
            type: String,
            required: true,
        },
        consentLinkUrl: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        redirectUrl: {
            type: String,
            required: true,
        },
        cancelButtonText: {
            type: String,
            required: true,
        },
        logoUrl: {
            type: String,
            required: false,
        },
        showOnPageLoad: {
            type: Boolean,
            default: false,
        },
    },
	components: {
		DsButton,
		DsButtonGroup,
		DsText,
		DsModal
	},
    data() {
        return {
            active: false,
            consentGiven: false,
            signupUrl: this.redirectUrl
        }
    },
    computed: {
        consentLink() {
            return `<a href="${this.consentLinkUrl}" target="_blank">${this.consentLinkText}</a>`;
        },
        consent() {
            return this.consentText.replace('$link$', this.consentLink);
        }
    },
    methods: {
        hide() {
            this.active = false;

			const event = new CustomEvent(Events.INACTIVATE_CONSUMER_SIGNUP, {});
			document.dispatchEvent(event);
        },
        show(event) {
            if (event.detail) {
                let match = /([?&]state=)[^&]+/.exec(this.signupUrl);
                if (match) {
                    this.signupUrl = this.signupUrl.replace(match[0], `${match[1]}${event.detail}`);
                }
                else {
					this.signupUrl = `${this.signupUrl}&state=${event.detail}`;
                }
            }
            this.active = true;
        },
        redirect() {
            window.location.assign(this.signupUrl);
        },
    },
    mounted() {
		this.$nextTick(() => this.active = this.showOnPageLoad );

        document.addEventListener(Events.ACTIVATE_CONSUMER_SIGNUP, this.show.bind(this));
    },
	unmounted() {
		document.removeEventListener(Events.ACTIVATE_CONSUMER_SIGNUP, this.show.bind(this));
	}
}
</script>
